import moment from 'moment'
import { get, filter } from 'lodash'

const prepareDate = item => {
  return {
    id: item.date,
    label: moment(item.date).format('DD/MM/YYYY')
  }
}

// removido pois agora esta sendo controlado pelo menu
// const status = {
//   scheduled: 'Agendado',
//   attended: 'Atendido',
//   absent: 'Ausente',
//   in_attendance: 'Em atendimento'
// }

const prepareSchedule = schedule => {
  if (schedule.status === 'available' || schedule.status === 'reserved') {
    schedule.otpions = [
      {value: 'available', text: 'Disponível'},
      {value: 'reserved', text: 'Reservado'}
    ]
  }
  if (schedule.status === 'scheduled') {
    schedule.otpions = [
      {value: 'scheduled', text: 'Agendado'},
      {value: 'delayed', text: 'Atrasado'},
      {value: 'attended', text: 'Atendido'},
      {value: 'absent', text: 'Ausente'},
      {value: 'canceled', text: 'Cancelado'},
      {value: 'in_attendance', text: 'Em Atendimento'},
      {value: 'present', text: 'Presente'},
      {value: 'reserved', text: 'Reservado'},
      {value: 'available', text: 'Disponível'}
    ]
  }
  schedule.covenant = get(schedule, 'covenant.name', 'Não informado')
  schedule.patient = get(schedule, 'patient', 'Integração Medibook - Offline')
  // schedule.speciality = get(schedule, 'speciality.name', 'Não informada')
  schedule.time = moment(schedule.date).format('HH:mm')
  schedule.status = get(status, schedule.status, schedule.status)
  // schedule.status = schedule.status

  return schedule
}

const prepareShow = agenda => {
  agenda.schedules = agenda.schedules.map(prepareSchedule)

  return agenda
}

export default {
  setFirstAgenda (data) {
    if (data.length > 0) {
      this.selectedAgenda(data[0])
    }
  },

  // Transferindo agendamento
  doTransfer (schedule) {
    // Get para dados do currentProfessional
    this.$http.get('v1/search/professionals/professionals/' + this.agenda.professional_id)
          .then(({data}) => {
            const professional = {...data}
            this.currentSchedule = {...schedule, 'professional': {...professional}}
            this.showModalTransfer = true
          })
          .catch(() => {
          })
  },
  // Revertendo transferencia
  doReverser (schedule) {
    this.$http.get('v1/search/professionals/professionals/' + this.agenda.professional_id)
          .then(({data}) => {
            const professional = {...data}
            this.currentSchedule = {...schedule, 'professional': {...professional}}
            this.showModalReverser = true
          })
          .catch(() => {
          })
  },
  selectedDate (date) {
    this.selectedAgenda(this.agenda)
  },
  // Proximos 30 dias agendados
  selectedAgenda (agenda) {
    if (agenda === null) {
      return
    }
    this.currentProfessional = agenda.professional
    this.date = null
    this.currentAgenda = agenda
    this.agenda_id = agenda.id

    const schedules = get(agenda, 'next_30dates', [])
    const dates = schedules.map(prepareDate)
    this.dates = dates
    if (dates.length > 0) {
      this.date = dates[0].id
    }
  },
  selectedAgendaAvailable (agenda) {
    if (agenda === null) {
      return
    }
    this.currentProfessional = agenda.professional
    this.date = null
    this.currentAgenda = agenda
    this.agenda_id = agenda.id

    const schedules = get(agenda, 'next_30dates', [])
    const dates = schedules.map(prepareDate)
    this.dates = dates
    if (dates.length > 0) {
      this.date = dates[0].id
    }
  },
  setCurrentSchedule (schedule) {
    this.currentSchedule = schedule
    this.showModal = true
  },
  // Agendamentos offline
  getSchedules () {
    this.schedules = []
    if (!this.date) {
      return
    }
    if (!this.agenda_id) {
      return
    }
    const data = {
      date: this.date
    }

    this.loading = true
    this.$resource.get(this.agenda_id + '/today/details/offline', data)
          .then(({data}) => {
            this.agenda = prepareShow(data)
            this.loading = false
          })
          .catch(() => {
            this.loading = false
          })
  },
  onSelectedRunAction (action, schedule = {}) {
    // Definindo como disponivel
    if (action === 'available') {
      const agenda = {
        agenda_name: this.agenda.name
      }
      this.schedulesSelected = [{...schedule, ...agenda}]
      this.showModalAvailable = true
    }
    // Definindo como reservado
    if (action === 'reserved') {
      const agenda = {
        agenda_name: this.agenda.name
      }
      this.schedulesSelected = [{...schedule, ...agenda}]
      this.showModalReserved = true
    }
    // Definindo como Atrasado
    if (action === 'delayed') {
      const agenda = {
        agenda_name: this.agenda.name
      }
      this.schedulesSelected = [{...schedule, ...agenda}]
      this.showModalDelayed = true
    }

    // RallBack para Agendado
    if (action === 'scheduled') {
      const agenda = {
        agenda_name: this.agenda.name
      }
      this.schedulesSelected = [{...schedule, ...agenda}]
      this.showModalFromDelayedRollback = true
    }

    // Definindo como Atendido
    if (action === 'attended') {
      const agenda = {
        agenda_name: this.agenda.name
      }
      this.schedulesSelected = [{...schedule, ...agenda}]
      this.showModalConfirmed = true
    }

    // Definindo como Ausente
    if (action === 'absent') {
      const agenda = {
        agenda_name: this.agenda.name
      }
      this.schedulesSelected = [{...schedule, ...agenda}]
      this.showModalAbsent = true
    }

    // Defindindo como Cancelado
    if (action === 'canceled') {
      const agenda = {
        agenda_name: this.agenda.name
      }
      this.schedulesSelected = [{...schedule, ...agenda}]
      this.showModalCancel = true
    }

    // Definindo em Atendimento
    if (action === 'in_attendance') {
      const agenda = {
        agenda_name: this.agenda.name
      }
      this.schedulesSelected = [{...schedule, ...agenda}]
      this.showModalInAttendance = true
    }

    // definindo como present
    if (action === 'present') {
      this.schedulesSelected = [{...schedule}]
      this.showModalPresent = true
    }
  },
  onCloseCancel (schedules) {
    this.showModalCancel = false
  },
  // Definindo como disponivel
  onCloseAvailable (schedules) {
    const data = filter(this.schedules, (schedule) => {
      return !find(schedules, {id: schedule.id})
    })

    this.schedules = [...data]
    this.showModalAvailable = false
    this.all = false
  },
  // Definindo como reservado
  onCloseReserved (schedules) {
    const data = filter(this.schedules, (schedule) => {
      return !find(schedules, {id: schedule.id})
    })

    this.schedules = [...data]
    this.showModalReserved = false
    this.all = false
  },
  // Confirmando como atendido
  onCloseConfirmed (schedules) {
    const data = filter(this.schedules, (schedule) => {
      return !find(schedules, {id: schedule.id})
    })

    this.schedules = [...data]
    this.showModalConfirmed = false
    this.all = false
  },
  onCloseAbsent (schedule) {
    const data = filter(this.schedules, (item) => {
      return schedule.id !== item.id
    })

    this.schedules = [...data]
    this.showModalAbsent = false
  },
  onCloseDelayed () {
    this.showModalDelayed = false
  },
  onCloseInAttendance () {
    this.showModalInAttendance = false
  },
  onClosePresent () {
    this.showModalPresent = false
  },
  onCloseRollback (schedules) {
    this.showModalRollback = false
  },
  onCloseFromFromDelayedRollback () {
    this.showModalFromDelayedRollback = false
  },
  onCloseReverser (schedule) {
    const data = filter(this.schedules, (item) => {
      return schedule.id !== item.id
    })

    this.schedules = [...data]
    this.showModalReverser = false
  },
  onCloseTransfer (schedule) {
    const data = filter(this.schedules, (item) => {
      return schedule.id !== item.id
    })

    this.schedules = [...data]
    this.showModalTransfer = false
  },
  hideShowModalDelayed () {
    this.showModalDelayed = false
  },
  hideshowModalConfirmed () {
    this.showModalConfirmed = false
  },
  hideShowModalAbsent () {
    this.showModalAbsent = false
  },
  hideShowModalInAttendance () {
    this.showModalInAttendance = false
  },
  hideShowModalPresent () {
    this.showModalPresent = false
  },
  hideShowModalRollback () {
    this.showModalRollback = false
  },
  hideShowModalFromDelayedRollback () {
    this.showModalFromDelayedRollback = false
  },
  hideShowModalReverser () {
    this.showModalReverser = false
  },
  hideShowModalTransfer () {
    this.showModalTransfer = false
  },
  hideShowModalReserved () {
    this.showModalReserved = false
  },
  hideShowModalAvailable () {
    this.showModalAvailable = false
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/professional/gadget/components/schedulings/resources/methods.js